export const WELL_KNOWN_ERROR_CODES = {
    ERR_INVALID_BIC: 657,
    ERR_NOT_ALLOWED_PAYMENT_TO_COUNTRY: 658,
    ERR_NOT_ALLOWED_SWIFT: 659,
    ERR_PREPAID_CARD_NOT_SUPPORTED: 3002,
    ERR_REJECT_ALL_OCT_DETECTED: 1000,
    ERR_CARD_PARTNER_IS_DOWN: 332,
    ERR_REJECT_ALL_AFT_DETECTED: 1001,
    ERR_COUNTRY_NOT_SUPPORTED: 3003,
    ERR_PAYMENT_METHOD_TO_COUNTRY_NOT_SUPPORTED: 3004,
    ERR_TYPE_OF_CARD_NOT_SUPPORTED: 3005,
    ERR_DUPLICATED_REGISTRATION: 59,
    ERR_WRONG_CODE: 43,
} as const;

export type WellKnownErrorCodeKey = keyof typeof WELL_KNOWN_ERROR_CODES;
export type WellKnownErrorCodeValue = (typeof WELL_KNOWN_ERROR_CODES)[WellKnownErrorCodeKey];

export const {
    ERR_INVALID_BIC,
    ERR_NOT_ALLOWED_PAYMENT_TO_COUNTRY,
    ERR_NOT_ALLOWED_SWIFT,
    ERR_PREPAID_CARD_NOT_SUPPORTED,
    ERR_REJECT_ALL_OCT_DETECTED,
    ERR_REJECT_ALL_AFT_DETECTED,
    ERR_COUNTRY_NOT_SUPPORTED,
    ERR_PAYMENT_METHOD_TO_COUNTRY_NOT_SUPPORTED,
    ERR_TYPE_OF_CARD_NOT_SUPPORTED,
    ERR_DUPLICATED_REGISTRATION,
    ERR_CARD_PARTNER_IS_DOWN,
    ERR_WRONG_CODE,
} = WELL_KNOWN_ERROR_CODES;
